.children-hidden {
  visibility: hidden;
  /* ensures that we keep the width of the button from
    shrinking but not grow the height */
  /*  height: 0;
  line-height: 0;*/
}

.button {
  &.loading,
  &:disabled {
    cursor: unset;
  }

  /* require these minimums for the loading dots */
  min-height: 24px;

  /* makes the above requirements easy to calculate w/ the variable
  paddings we use for buttons*/
  box-sizing: content-box;

  display: inline-block;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: none;
  text-decoration: none;

  outline: none;
  white-space: nowrap;

  & .loading-dotdotdot {
    /* prevents the button size from jumping around when showing the loading dots */
    height: 0;
    /*    display: flex;
    flex-flow: row;
    align-items: center;*/
    position: relative;
    top: 4px;
  }

  & .loading-dotdotdot * {
    fill: white;
  }

  & .loading-spinner {
    margin: 0 auto; /* centers the spinner wherever it is */
  }
}

.loading-spinner-wrapper {
  height: 0;
  position: relative;
  top: 1px;
}

.button.tableAction {
  display: flex;
  align-items: center;
  text-align: center;

  /* size not sanctioned by :plainswarrior: */
  &.size-14px {
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.6px;
    padding: 2px 10px;
  }

  /* size not sanctioned by :plainswarrior: */
  &.size-15px {
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.6px;
    padding: 2px 12px;
  }

  &.size-17px {
    border-radius: 8px;
    font-size: 17px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0.8px;
    padding: 4px 16px;
  }

  /* size not sanctioned by :plainswarrior: */
  &.size-19px {
    border-radius: 8px;
    font-size: 17px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0.8px;
    padding: 4px 16px;
  }

  border: 3px solid #39493f;
  background-color: #192a22;
  color: var(--ds-white);

  &:not(.disabled) {
    &:focus,
    &:hover {
      border-color: #858e88;
      background-color: #314537;
      outline: none;
    }
  }

  &.disabled {
    opacity: 0.24;
  }
}

/* LEGACY STYLES BELOW*/

.button.primary,
.button.primary-dark,
.button.secondary,
.button.tertiary-destructive {
  &.disabled {
    opacity: 0.24;
  }

  &.size-14px {
    font-size: 14px;
    letter-spacing: 0.6px;
    line-height: 24px;
    border-radius: 28px;
    padding: 4px 16px;
  }

  &.size-15px {
    font-size: 15px;
    letter-spacing: 0.6px;
    line-height: 24px;
    border-radius: 28px;
    padding: 8px 32px;
    & svg:not(:last-child) {
      margin-right: 12px;
    }
  }
  &.size-17px {
    font-size: 17px;
    letter-spacing: 0.8px;
    line-height: 28px;
    border-radius: 24px;
    padding: 8px 32px;
    & svg:not(:last-child) {
      margin-right: 16px;
    }
  }
  &.size-19px {
    font-size: 19px;
    letter-spacing: 0.8px;
    line-height: 28px;
    border-radius: 26px;
    padding: 10px 32px;
  }
}

.button.primary {
  font-weight: 700;
  color: #ffffff;
  background-color: var(--ds-blue-light);
  &:hover:not(.disabled) {
    background-color: var(--ds-blue-light-hover);
  }

  &:focus {
    /* The box-shadow value is temporary until the DS is updated wih focus states */
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
    outline-offset: 4px;
  }
}

.button.primary-dark {
  font-weight: 700;
  color: #ffffff;
  background-color: var(--ds-blue-dark);
  &:hover:not(.disabled) {
    background-color: var(--ds-blue-dark-hover);
  }
  &.shadow {
    box-shadow:
      0px 9px 23px rgba(53, 71, 180, 0.16),
      0px 12px 15px rgba(53, 71, 180, 0.2);
  }
}

.button.secondary {
  font-weight: 700;
  color: var(--ds-blue);
  background-color: var(--ds-pearl-grey);
  &:hover:not(.disabled) {
    background-color: var(--ds-pearl-grey-hover);
  }
}

.button.tertiary-destructive {
  font-weight: 700;
  color: var(--ds-red-dark);
  background-color: var(--ds-off-white);
  &:hover:not(.disabled) {
    background-color: var(--ds-off-white-dark);
  }

  & .loading-dotdotdot * {
    fill: var(--ds-red-dark);
  }

  border: solid 1px transparent;

  &:hover:not(.disabled) {
    background-color: var(--ds-red-light);
    border-color: var(--ds-red-dark);
  }
}
